module.exports = Date.now || now

function now() {
    return new Date().getTime()
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-json-inspector/~/debounce/~/date-now/index.js
 ** module id = 326
 ** module chunks = 0
 **/